/**
 * 互动问答表格
 * todo 拆分编辑、添加为单个页面
 * Create by liaokai on 2020-05-25 18:55:45
 */
import * as React from "react";
import {Button, Input, message, Modal, Radio, Select, Spin, Switch, Table} from "antd";
import {TitleContentTable} from "../../../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";
import {replyKeywords} from "../../../../../../../common/apis/apis/live/replyKeywordsList";
import {FlexJustifyCenter} from "../../../../../../../components/style/flex/flex-justify-center";
import {Air} from "../../../../../../../components/air/Air";
import {liveStore as liveStoreReq} from "../../../../../../../common/apis/apis/live/liveStore";
import {liveStore} from "../../live.store";
import {liveUpdate} from "../../../../../../../common/apis/apis/live/liveUpdate";
import {Component} from "react";
import {attentionInfo} from "../../../../../../../common/apis/apis/live/attentionInfo";
import {autoMessage} from "../../../../../../../common/apis/apis/live/autoMessage";
import {attentionUpdate} from "../../../../../../../common/apis/apis/live/attentionUpdate";
import {autoMessageSet} from "../../../../../../../common/apis/apis/live/autoMessageSet";

interface IProp {

}

interface IState {
    'live_id'?:any,
    'seconds'?:number,
    'status'?:number,
    'type'?:string,
}

export class RobotChatStoreView extends Component<IProp,IState>{
    readonly state : IState = {
        live_id:liveStore.live_id,
        seconds: 1,
        status: 0,
        type: "1",
    }
    componentDidMount(): void {
        autoMessage({live_id:liveStore.live_id}).then(res=>{
            this.setState({
                live_id:liveStore.live_id,
                seconds: res.seconds ? res.seconds : 1,
                status:res.status ? res.status : 0,
                type:res.type ? String (res.type) : "1",
            })
        })
    }
    render() {
        const {live_id,seconds,status,type} = this.state

        return (
            <>
                <TitleContentTable rowGap={12} colGap={12}>
                    <div>类型</div>
                    <Select
                        style={{width:"300px",  display: "flex", flexDirection: "row" }}
                        defaultValue={type}
                        onChange={(value  :any)=>{
                                this.setState({type:value})
                        }}
                    >
                        <Select.Option  value="1">会前</Select.Option>
                        <Select.Option  value="2">会中</Select.Option>
                        <Select.Option  value="3">会后</Select.Option>
                    </Select>
                    <div>频次/秒</div>
                    <Input
                        style={{width:"300px",  display: "flex", flexDirection: "row" }}
                        // width={'50px'}
                        placeholder={"请输入频次/秒"}
                        type={"number"}
                        value={seconds}
                        onChange={(e) => {
                            this.setState({seconds:Number(e.target.value)})
                        }}
                    />
                    <div>开关</div>
                    <Switch
                        style={{ width: "10px" }}
                        checked={status === 1}
                        onChange={(value) => {
                            console.log(value)
                            this.setState({status:value?1:0})
                        }}
                    />
                    <Air vertical={30} />

                </TitleContentTable>
                <FlexJustifyCenter>
                    <Button
                        type={"primary"}
                        onClick={()=>{
                            autoMessageSet({live_id:liveStore.live_id,type:type,status:status,seconds:seconds})
                                .then(
                                    message.success('保存成功')
                                ).catch((e) => {
                                message.error(
                                    e.data?.message
                                );
                            })
                        }}
                    >
                        保存
                    </Button>
                </FlexJustifyCenter>
            </>
        );
    }


}
